// SP: Sticker Club "Kit timing" month picker (Figma 3402:2321). Three month chips
// from the visitor's current month, an on/before vs after the 28th switch, and
// a live answer. Same rule as sp-sc-date-calculator.js and the page's FAQ:
// on/before the 28th of month M -> first kit M+2, ships mid M+1;
// after the 28th -> first kit M+3, ships mid M+2.
(function () {
  var NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];
  var ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function add(y, m, n) {
    var t = m + n;
    return { y: y + Math.floor(t / 12), m: ((t % 12) + 12) % 12 };
  }

  function init(root) {
    var months = root.querySelector('[data-sp-kt-months]');
    var days = root.querySelectorAll('[data-sp-kt-day]');
    var kitEl = root.querySelector('[data-sp-kt-kit]');
    var shipsEl = root.querySelector('[data-sp-kt-ships]');
    if (!months || !kitEl || !shipsEl || days.length !== 2) return;

    var cutoff = parseInt(root.dataset.cutoff, 10) || 28;
    var shipDay = parseInt(root.dataset.shipDay, 10) || 15;
    var now = new Date();
    var nowY = now.getFullYear(), nowM = now.getMonth();
    var pastCutoff = now.getDate() > cutoff;
    if (pastCutoff) { var nx = add(nowY, nowM, 1); nowY = nx.y; nowM = nx.m; }
    var CHIPS = 2;
    var name = 'sp-kt-month-' + Math.random().toString(36).slice(2, 8);

    var html = '';
    for (var i = 0; i < CHIPS; i++) {
      var d = add(nowY, nowM, i);
      html += '<label class="sp-sc-kt__chip"><input type="radio" name="' + name + '" value="' + i + '"' +
        (i === 0 ? ' checked' : '') + '><span>' + ABBR[d.m] + ' ' + d.y + '</span></label>';
    }
    months.innerHTML = html;
    var chips = months.querySelectorAll('input');

    function update() {
      var i = 0;
      chips.forEach(function (c) { if (c.checked) i = parseInt(c.value, 10); });
      var before = days[0].checked;

      var kit = add(nowY, nowM, i + (before ? 2 : 3));
      var ship = add(nowY, nowM, i + (before ? 1 : 2));
      var ord = kit.y * 12 + kit.m;
      var dir = lastOrd == null ? 0 : ord > lastOrd ? 1 : ord < lastOrd ? -1 : 0;
      lastOrd = ord;
      put(kitEl, 'kit', NAMES[kit.m] + ' ' + kit.y, dir);
      put(shipsEl, 'ship', 'Mid-' + ABBR[ship.m], dir);
    }

    var lastOrd = null;
    var cands = { kit: [], ship: [] };
    for (var ci = 0; ci < CHIPS; ci++) {
      [2, 3].forEach(function (o) {
        var k = add(nowY, nowM, ci + o), s = add(nowY, nowM, ci + o - 1);
        var kv = NAMES[k.m] + ' ' + k.y, sv = 'Mid-' + ABBR[s.m];
        if (cands.kit.indexOf(kv) < 0) cands.kit.push(kv);
        if (cands.ship.indexOf(sv) < 0) cands.ship.push(sv);
      });
    }

    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var DUR = 520;
    var STEP = 30;

    function cell(el, key) {
      var live = el.querySelector(':scope > .sp-kt-swap > .sp-kt-live');
      if (live) return live;
      var html = '<span class="sp-kt-swap">';
      (cands[key] || []).forEach(function (c) { html += '<span class="sp-kt-size" aria-hidden="true">' + c + '</span>'; });
      el.innerHTML = html + '<span class="sp-kt-live"></span></span>';
      return el.querySelector('.sp-kt-live');
    }

    function tokens(s) { return s.match(/[A-Za-z]+|\d|[^A-Za-z\d]+/g) || []; }

    function tokHtml(t) { return '<span class="sp-kt-tok"><span class="sp-kt-face">' + t + '</span></span>'; }

    function put(el, key, v, dir) {
      var live = cell(el, key);
      var old = live.getAttribute('data-v');
      if (old === v) return;
      live.setAttribute('data-v', v);
      var a = tokens(old || ''), b = tokens(v);
      if (old == null || reduce || !live.animate || a.length !== b.length || live.children.length !== a.length) {
        live.innerHTML = b.map(tokHtml).join('');
        return;
      }
      var d = dir || 1;
      var first = -1;
      for (var i = 0; i < b.length; i++) {
        if (a[i] === b[i]) continue;
        if (first < 0) first = i;
        var lag = (i - first) * STEP;
        roll(live.children[i], b[i], d, lag);
      }
    }

    function roll(tok, t, d, lag) {
      tok.getAnimations({ subtree: true }).forEach(function (an) { an.finish(); });
      var faces = tok.querySelectorAll('.sp-kt-face');
      for (var f = 0; f < faces.length - 1; f++) faces[f].remove();
      var oldFace = tok.querySelector('.sp-kt-face');
      var w0 = tok.getBoundingClientRect().width;
      var newFace = document.createElement('span');
      newFace.className = 'sp-kt-face';
      newFace.textContent = t;
      oldFace.setAttribute('aria-hidden', 'true');
      oldFace.style.position = 'absolute';
      oldFace.style.left = '0';
      oldFace.style.top = '0';
      tok.appendChild(newFace);
      var w1 = newFace.getBoundingClientRect().width;
      if (w0 !== w1) tok.animate([{ width: w0 + 'px' }, { width: w1 + 'px' }], { duration: DUR, easing: EASE, delay: lag });
      tok.classList.add('is-rolling');
      oldFace.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateY(' + (-100 * d) + '%)', opacity: 0 }],
        { duration: DUR, easing: EASE, delay: lag, fill: 'forwards' }).onfinish = function () { oldFace.remove(); };
      newFace.animate([{ transform: 'translateY(' + (100 * d) + '%)', opacity: 0 }, { transform: 'none', opacity: 1 }],
        { duration: DUR, easing: EASE, delay: lag, fill: 'backwards' }).onfinish = function () {
        if (tok.querySelectorAll('.sp-kt-face').length < 2) tok.classList.remove('is-rolling');
      };
    }

    root.addEventListener('change', update);
    update();

    var ctaText = root.querySelector('[data-sp-kt-cta-late]');
    if (ctaText) {
      var late = ctaText.getAttribute('data-sp-kt-cta-late');
      var day = now.getDate();
      var mid = ctaText.getAttribute('data-sp-kt-cta-mid');
      var want = late && day >= cutoff - 14 && day <= cutoff ? late
        : mid && day >= 5 && day < cutoff - 14 ? mid
        : ctaText.getAttribute('data-sp-kt-cta-early');
      if (want && ctaText.textContent.trim() !== want) ctaText.textContent = want;
    }

    var cta = root.querySelector('[data-sp-kt-add]');
    if (cta) cta.addEventListener('click', function (e) {
      var btn = document.querySelector('form.js-product-form[id*="__main"]:not([id$="-sticky"]) button[name="add"]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      btn.click();
    });
    root.classList.add('is-ready');
  }

  function boot() { document.querySelectorAll('[data-sp-kit-timing]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
